module.exports = __webpack_public_path__ + "img/icon_bolang.35cfcc31.png";